"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentProvider = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importStar(require("react"));
var react_query_1 = require("react-query");
var axios_1 = __importDefault(require("axios"));
var defaultContent = {
    applications: {
        active: '',
        concept: '',
        completed: '',
    },
    vacanciesNoSuggested: '',
    vacanciesSearchExplanation: '',
    vacanciesSuggestedExplanation: '',
    vacancies: {
        buttonApply: '',
        textApply: '',
        buttonShare: '',
        textShare: '',
    },
    vacanciesDetailsTooltip: '',
    rfCard: {
        title: '',
        leftColumn: '',
        rightColumn: '',
    },
    applyDialog: {
        registerSubTitle: '',
        registerBlock: '',
        motivationTips: '',
    },
    connections: {
        noConnections: '',
        noInvites: '',
        noSharedVacancies: '',
    },
};
var ContentContext = react_1.default.createContext(defaultContent);
function ContentProvider(_a) {
    var children = _a.children;
    var _b = (0, react_query_1.useQuery)('content', function () { return axios_1.default.get('/data/content'); }), isLoading = _b.isLoading, error = _b.error, data = _b.data;
    var content = (0, react_1.useMemo)(function () {
        if (isLoading || error || !data) {
            return defaultContent;
        }
        return data.data;
    }, [isLoading, error, data]);
    return (0, jsx_runtime_1.jsx)(ContentContext.Provider, __assign({ value: content }, { children: children }));
}
exports.ContentProvider = ContentProvider;
exports.default = ContentContext;
